import React from 'react';
import { useSelector } from 'react-redux';
import getDesignedProduct from 'store/product/selector/getDesignedProduct';
import H1Title from 'components/Common/H1Title/H1Title';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import generateAuthorHtml from 'utils/authorHtml';
import getProductItem from 'store/product/selector/getProductItem';
import getProductTypeTranslationKey from 'utils/getProductTypeTranslationKey';
import styles from './ProductTitle.module.scss';

interface Props {
  showCategoryName?: boolean;
}

const ProductTitle = ({ showCategoryName }: Props) => {
  const product = useSelector(getDesignedProduct);
  const designName = product?.content.designName;
  const author = product?.content.designAuthorName;
  const categoryName = product?.content.productPageCategoryName;
  const isShutterStock = product?.content.isShutterstockDesign;
  const content = product?.content;
  const isGettyImagesDesign = content ? (content as any).isGettyImagesDesign : false;
  const nonExternalStockDesign = !isShutterStock && !isGettyImagesDesign;
  const searchByAuthorNameQuery = `/search?query=${author}`;
  const productTypeId = useSelector(getProductItem)?.product.productTypeId;
  const productTypeTitle = productTypeId && getProductTypeTranslationKey(productTypeId);

  const { t } = useTranslation();

  const authorHtml = author
    ? generateAuthorHtml(!!isShutterStock, isGettyImagesDesign, nonExternalStockDesign, t, styles.author, author)
    : '';

  return (
    <div className={styles.productTitle} itemScope itemType="http://schema.org/Product">
      {showCategoryName && categoryName && <div className={styles.categoryName}>{categoryName}</div>}
      <h1 className={styles.headline} itemProp="name">
        {designName} {t(productTypeTitle || '')}
      </h1>
      {author && (
        <div className={styles.designAuthor} itemProp="author">
          <Link to={searchByAuthorNameQuery}>
            <span dangerouslySetInnerHTML={{ __html: authorHtml }} />
          </Link>
        </div>
      )}
    </div>
  );
};

export default ProductTitle;
